// extracted by mini-css-extract-plugin
export default {"column":"styles_column__zgk9p","tasks":"styles_tasks__gB5NJ","delete":"styles_delete__2Pv-e"};